import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useMemo } from 'react'
import { useMenuAnalyticsLayoutContext } from 'widgets/Menu/ui/MenuAnalytics'
import { AnalyticsLayoutStore } from 'pages/analytics/store/analyticsLayoutStore'
import { AnalyticsLayoutContext } from 'pages/analytics/context/analyticsLayoutContext'

export const AnalyticsLayout = observer(() => {
  const menuLayoutStore = useMenuAnalyticsLayoutContext()
  const pageStore = useMemo(() => new AnalyticsLayoutStore(menuLayoutStore.pageLayoutStore), [])

  return (
    <AnalyticsLayoutContext.Provider value={pageStore}>
      <Outlet />
    </AnalyticsLayoutContext.Provider>
  )
})
